/**
 * heute icons — ported verbatim from the mock bundle's icons.jsx (pixel
 * truth): minimal stroke set, 1.8 stroke-width, rounded line caps. Only the
 * subset shipped surfaces need; extend from icons.jsx as screens land.
 */
export type IconName =
	| 'run'
	| 'coffee'
	| 'fork'
	| 'wave'
	| 'bike'
	| 'vinyl'
	| 'campfire'
	| 'music'
	| 'sparkles'
	| 'clock'
	| 'pin'
	| 'lightning'
	| 'check'
	| 'plus'
	| 'link'
	| 'share'
	| 'chevron-right'
	| 'calendar'
	| 'send'
	| 'arrow-up'
	| 'bell'
	| 'bell-off'
	| 'tandwiel'
	| 'users'
	| 'search'
	| 'dots'
	| 'map'
	| 'chevron-left'
	| 'camera'
	| 'image'
	| 'compass'
	| 'heart'
	| 'star'
	| 'x'
	| 'vraag'
	| 'loop'
	| 'store'
	| 'bookmark'
	| 'lock'
	| 'flag'
	| 'ticket'
	| 'repeat'
	| 'potlood'
	| 'qr'
	| 'bericht'
	| 'rugzak'
	| 'euro'
	| 'zon'
	| 'schaduw'
	| 'navigatie'
	| 'mic'
	| 'hand'

const PATHS: Record<IconName, React.ReactNode> = {
	run: (
		<>
			<circle cx="14" cy="5" r="1.6" />
			<path d="M9 21l2-5-3-2-2 3M11 16l4 1 1-4-3-2-3 3" />
			<path d="M16 21l-1-4" />
		</>
	),
	coffee: (
		<>
			<path d="M4 8h13v6a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4z" />
			<path d="M17 10h2a2 2 0 0 1 0 4h-2" />
			<path d="M8 3c0 1.5 1 1.5 1 3M12 3c0 1.5 1 1.5 1 3" />
		</>
	),
	fork: (
		<>
			<path d="M7 3v8M11 3v8M9 11v10M7 3a2 2 0 0 0 0 4 2 2 0 0 0 0-4M11 3a2 2 0 0 0 0 4 2 2 0 0 0 0-4" />
			<path d="M17 3c-1 0-2 1-2 4s1 4 2 4M17 11v10" />
		</>
	),
	wave: (
		<>
			<path d="M5 10c2-3 5-3 7 0s5 3 7 0" />
			<path d="M5 14c2-3 5-3 7 0s5 3 7 0" />
		</>
	),
	bike: (
		<>
			<circle cx="6" cy="17" r="3.5" />
			<circle cx="18" cy="17" r="3.5" />
			<path d="m6 17 5-7h5l2-4h2M11 10l3 7M11 10h4" />
		</>
	),
	vinyl: (
		<>
			<circle cx="12" cy="12" r="8.5" />
			<circle cx="12" cy="12" r="2.5" />
		</>
	),
	campfire: (
		<>
			<path d="M12 13c-2-2-2-5 0-8 0 2 3 4 3 7a3 3 0 0 1-6 0c0-1 1-2 1-3 1 1 2 2 2 4z" />
			<path d="M4 19l16 0" />
			<path d="M5 21l14 0" />
		</>
	),
	music: (
		<>
			<path d="M9 18V5l11-2v13" />
			<circle cx="6" cy="18" r="3" />
			<circle cx="17" cy="16" r="3" />
		</>
	),
	sparkles: (
		<>
			<path d="M12 4v4M12 16v4M4 12h4M16 12h4" />
			<path d="m6 6 2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6" />
		</>
	),
	clock: (
		<>
			<circle cx="12" cy="12" r="8.5" />
			<path d="M12 7v5l3 2" />
		</>
	),
	pin: (
		<>
			<path d="M12 21s7-7.6 7-13a7 7 0 1 0-14 0c0 5.4 7 13 7 13z" />
			<circle cx="12" cy="8" r="2.5" />
		</>
	),
	lightning: <path d="M13 3 5 14h5l-1 7 8-11h-5z" />,
	check: <path d="m4 12 5 5L20 6" />,
	plus: <path d="M12 5v14M5 12h14" />,
	link: (
		<>
			<path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" />
			<path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 1 0 5.7 5.7l1-1" />
		</>
	),
	share: (
		<>
			<path d="M12 4v12" />
			<path d="m8 8 4-4 4 4" />
			<path d="M5 14v5h14v-5" />
		</>
	),
	'chevron-right': <path d="m9 6 6 6-6 6" />,
	calendar: (
		<>
			<rect x="3.5" y="5" width="17" height="16" rx="3" />
			<path d="M3.5 10h17" />
			<path d="M8 3v4M16 3v4" />
		</>
	),
	send: <path d="M5 12h14M12 5l7 7-7 7" />,
	'arrow-up': <path d="M12 19V5M5 12l7-7 7 7" />,
	bell: (
		<>
			<path d="M6 16V11a6 6 0 0 1 12 0v5l1.5 2H4.5z" />
			<path d="M10 21a2 2 0 0 0 4 0" />
		</>
	),
	'bell-off': (
		<>
			<path d="M6 16V11a6 6 0 0 1 9.4-4.9M18 11v5l1.5 2H8" />
			<path d="M10 21a2 2 0 0 0 4 0" />
			<path d="M4 4l16 16" />
		</>
	),
	tandwiel: (
		<>
			<circle cx="12" cy="12" r="3" />
			<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
		</>
	),
	users: (
		<>
			<circle cx="9" cy="8" r="3.5" />
			<path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
			<circle cx="17" cy="9" r="2.6" />
			<path d="M15 14.5c2.5-.4 5 1.4 5.4 4" />
		</>
	),
	search: (
		<>
			<circle cx="11" cy="11" r="6.5" />
			<path d="m16 16 4.5 4.5" />
		</>
	),
	dots: (
		<>
			<circle cx="5" cy="12" r="1.1" />
			<circle cx="12" cy="12" r="1.1" />
			<circle cx="19" cy="12" r="1.1" />
		</>
	),
	map: (
		<>
			<path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2z" />
			<path d="M9 4v14M15 6v14" />
		</>
	),
	'chevron-left': <path d="m15 6-6 6 6 6" />,
	camera: (
		<>
			<path d="M4 8h3l2-3h6l2 3h3a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z" />
			<circle cx="12" cy="13" r="3.5" />
		</>
	),
	image: (
		<>
			<rect x="3.5" y="4.5" width="17" height="15" rx="2" />
			<circle cx="9" cy="10" r="2" />
			<path d="m4 18 5-5 4 4 3-3 4 4" />
		</>
	),
	// mock icons.jsx fills the needle; stroked here — PATHS inherit the
	// svg's fill="none" and the outline reads at 20px just the same
	// ronde 4: de locatievraag (het pijltje van je eigen plek)
	navigatie: <path d="M20 4 4 11l7 2 2 7z" />,
	compass: (
		<>
			<circle cx="12" cy="12" r="8.5" />
			<path d="m9 15 2-6 6-2-2 6z" />
		</>
	),
	// S9 volgen-surface — 1-op-1 uit de mock-vocabulaire (icons.jsx)
	heart: <path d="M12 20s-7-4.5-7-10a4.5 4.5 0 0 1 8-3 4.5 4.5 0 0 1 8 3c0 5.5-7 10-7 10" />,
	star: (
		<path d="M12 3.2l2.5 5.4 5.9.6-4.4 4 1.2 5.8L12 16l-5.2 3 1.2-5.8-4.4-4 5.9-.6z" />
	),
	x: <path d="M6 6 18 18M18 6 6 18" />,
	// ontwerp v4 (vegen op Vandaag): misschien en onderweg
	vraag: (
		<>
			<circle cx="12" cy="12" r="9" />
			<path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5v.4" />
			<path d="M12 16.8v.2" />
		</>
	),
	loop: (
		<>
			<circle cx="13" cy="4.5" r="1.6" />
			<path d="M10 21l2-6-2.5-2 1-4.5 3 2.5 3 .5" />
			<path d="M9.5 8.5 7 11v3" />
			<path d="M12 15l3 2 1 4" />
		</>
	),
	bookmark: <path d="M6 4h12v17l-6-4-6 4z" />,
	lock: (
		<>
			<rect x="5" y="11" width="14" height="9" rx="2" />
			<path d="M8 11V8a4 4 0 0 1 8 0v3" />
		</>
	),
	flag: (
		<>
			<path d="M6 21V4" />
			<path d="M6 5c2-1.4 4-1.4 6 0s4 1.4 6 0v8c-2 1.4-4 1.4-6 0s-4-1.4-6 0" />
		</>
	),
	ticket: (
		<>
			<path d="M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4z" />
			<path d="M14 6v12" strokeDasharray="2 3" />
		</>
	),
	store: (
		<>
			<path d="M4 10V8l2-4h12l2 4v2a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0z" />
			<path d="M5 10v10h14V10" />
		</>
	),
	// een reeks (Vandaag v2, de open kaart): twee pijlen in een rondje,
	// het herhaalteken van het canvas "heute vijf richtingen"
	repeat: (
		<>
			<path d="M17 2l3 3-3 3" />
			<path d="M4 11V9a4 4 0 0 1 4-4h12" />
			<path d="M7 22l-3-3 3-3" />
			<path d="M20 13v2a4 4 0 0 1-4 4H4" />
		</>
	),
	// Dank je (Vandaag v2, scherm 05): een opgestoken hand
	hand: (
		<>
			<path d="M8 13V5.5a1.5 1.5 0 0 1 3 0V11" />
			<path d="M11 10V4.5a1.5 1.5 0 0 1 3 0V11" />
			<path d="M14 10.5V6a1.5 1.5 0 0 1 3 0v7.5c0 4-2.5 7-6.5 7-3 0-4.5-1.5-6-4l-1.6-2.7a1.5 1.5 0 0 1 2.5-1.6L8 14" />
		</>
	),
	// de planpagina (canvas app-details): Wijzig, en het kaartje
	potlood: <path d="M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z" />,
	qr: (
		<>
			<rect x="4" y="4" width="6" height="6" rx="1" />
			<rect x="14" y="4" width="6" height="6" rx="1" />
			<rect x="4" y="14" width="6" height="6" rx="1" />
			<path d="M14 14h2v2M20 14v6h-6M17 17h.01" />
		</>
	),
	// de tegels van de planpagina (ontwerp v4, bron/app.js): het gesprek,
	// wie neemt wat mee en wie betaalde wat
	bericht: <path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z" />,
	rugzak: (
		<>
			<path d="M5 11a7 7 0 0 1 14 0v8a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z" />
			<path d="M9 5V4a3 3 0 0 1 6 0v1" />
			<path d="M8 15h8v3H8z" />
		</>
	),
	euro: (
		<>
			<path d="M18 6.5a7 7 0 1 0 0 11" />
			<path d="M4 10h9M4 14h9" />
		</>
	),
	// een plan zeggen: de microfoon in de typbalk (docs/heute-spraak-mock.html)
	mic: (
		<>
			<rect x="9" y="3" width="6" height="11" rx="3" />
			<path d="M5.5 11a6.5 6.5 0 0 0 13 0" />
			<path d="M12 17.5V21" />
		</>
	),
	// de weetjes: zon op het terras, of schaduw (een half gevulde zon)
	zon: (
		<>
			<circle cx="12" cy="12" r="4" />
			<path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
		</>
	),
	schaduw: (
		<>
			<circle cx="12" cy="12" r="7" />
			<path d="M12 5a7 7 0 0 0 0 14z" fill="currentColor" />
		</>
	),
}

export function Icon({
	name,
	size = 22,
	stroke = 1.8,
	color = 'currentColor',
	style,
	className,
}: {
	name: IconName
	size?: number
	stroke?: number
	color?: string
	style?: React.CSSProperties
	className?: string
}) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth={stroke}
			strokeLinecap="round"
			strokeLinejoin="round"
			style={style}
			className={className}
			aria-hidden="true"
		>
			{PATHS[name]}
		</svg>
	)
}
